import { Logger, createLoggerWithAllHandlers } from '../helpers/bi';
import * as React from 'react';
import * as sentry from '@sentry/browser';
import {hydrate} from 'react-dom';

import './style.global.scss';

import { Account } from './comp';
import { triggerBindEvent } from '../helpers/bi/bind-event';
import { isDebugClient } from '../helpers/shared';
import { getGlobalTranslateSource } from '../helpers/translate';
import { createTranslateFn, createSentryReporter } from '@wix/answers-lib';

const getReleaseVersion = (aw: AugmentedWindow) => {
	try {
		const matches = aw.__baseStaticsUrl.match(/\d+\.\d+\.\d+/);
		return matches ? matches[0] : 'error-parsing-release-a';
	} catch (e) {
		return 'error-parsing-release-b';
	}
};

triggerBindEvent();

const logger: Logger = createLoggerWithAllHandlers({locale: 'en'}, isDebugClient());

const tempTranslations = {
	// 'marketing-site.signup.wix-sso-error.title': 'Something went wrong in the signup process..',
	// 'marketing-site.signup.wix-sso-error.description': 'Try <a href=\'/signup\'>signing up</a> again',
	// 'marketing-site.signup.wix-sso-error.contact': 'If the issue persists, let us know at <a href=\'//help.wixanswers.com/en/contact\'>help.wixanswers.com</a>',
	'marketing-site.signup-form.signup.fields.organization-size' : 'Company Size',
	'marketing-site.signup-form.signup.fields.phone-number' : 'Phone Number',
	'marketing-site.signup-form.signup.organization-size.1' : '1-4',
	'marketing-site.signup-form.signup.organization-size.2' : '5-9',
	'marketing-site.signup-form.signup.organization-size.3' : '10-49',
	'marketing-site.signup-form.signup.organization-size.4' : '50-199',
	'marketing-site.signup-form.signup.organization-size.5' : '200-499',
	'marketing-site.signup-form.signup.organization-size.6' : '500-999',
	'marketing-site.signup-form.signup.organization-size.7' : '1000+',
	'marketing-site.signup-form.signup.errors.organization-size' : 'Please select an estimated team size',
	'marketing-site.signup-form.signup.errors.phone-invalid' : 'Invalid phone number',
};

const tSource = getGlobalTranslateSource().en;
const translate = createTranslateFn({...tempTranslations, ...tSource});

const errorReporter = createSentryReporter(sentry, 'https://044d8f8d830c4b409cc9320091cd0281@sentry.wixpress.com/1075');
errorReporter.setup(getReleaseVersion(window as any));

try {
	hydrate(<Account logger={logger} t={translate}/>, document.getElementById('root'));
} catch (e) {
	errorReporter.reportError((e as Error));
}
